import { SubscriptionsAsyncActions } from 'store/actions/subscriptions';
import { createReducerFromActions } from 'utils/store';
import { values } from 'lodash';

export default createReducerFromActions(...values(SubscriptionsAsyncActions));
